import { List, ListItem, Typography } from "@mui/material";

export const StoreItems = () => {

  const storeItems = [
    "Snacks",
    "Fire starters",
    "Kindling",
    "Firewood",
    "Basic OTC medication",
    "Toiletries",
    "Mosquito repellent products",
    "Sunscreen",
    "Butterfly nets",
    "Kitchen utensils",
    "Disposable dishes and utensils",
    "Basic fishing supplies",
    "Tent pegs",
    "Rope",
    "Flashlights",
    "Candles",
    "Decks of cards",
    "Towels",
    "Blankets",
    "Sleeping bags",
    "Condiments",
    "Dish soap",
    "Phone chargers",
    "Live bait"
  ]

  return (
    <div className="page">
      <Typography gutterBottom variant="h3" align="center">
        List of Store Items
      </Typography>
      <Typography variant="h6">We do our best to keep these in stock but we can't guarantee 
        we have everything on this list at all times. Thank you for your understanding!
      </Typography>
      <List
        sx={{
          listStyleType: "disc",
          pl: 2,
          "& .MuiListItem-root": {
            display: "list-item",
          },
        }}
      >
        {storeItems.map(item => <ListItem sx={{ pl: 0 }}>{item}</ListItem>)}
      </List>
    </div>
  );
};
